module.exports = __webpack_public_path__ + "2eae2da4d9878432da159d1f880d223d.svg";